import type { MfgSdsFooterState } from "@/lib/manufacturing/msdsDocumentTypes";
import type { MfgSdsSections } from "@/lib/manufacturing/msdsSections";

export type RenderSdsPdfArgs = {
  materialCode: string;
  materialName: string;
  plantName?: string;
  organizationName?: string;
  sections: MfgSdsSections;
  footerState?: MfgSdsFooterState | null;
  source?: string | null;
  generatedAt?: string | null;
  generatedByUserId?: string | null;
  promptVersion?: string | null;
  sourceInputsHash?: string | null;
  reviewerDisplayName?: string | null;
  reviewedAt?: string | null;
};

export type RenderSdsPdfResult = { ok: true; blob: Blob } | { ok: false; error: string };

/** Lazy-load @react-pdf/renderer for single-material SDS export. */
export async function renderSdsPdfToBlob(args: RenderSdsPdfArgs): Promise<RenderSdsPdfResult> {
  try {
    const [{ pdf }, { SdsPdf }] = await Promise.all([
      import("@react-pdf/renderer"),
      import("./SdsPdf"),
    ]);
    const blob = await pdf(SdsPdf(args)).toBlob();
    return { ok: true, blob };
  } catch (err) {
    return {
      ok: false,
      error: err instanceof Error ? err.message : "Failed to render SDS PDF",
    };
  }
}
